import { EditableColumn } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const SEditableColumn = styled(EditableColumn)``;
